<template>
  <div class="gc-report-pdf">
    <iframe
      id="pdf-container"
      v-if="setPdf"
      :src="setPdf"
      width="100%"
      height="100%"
    >
    </iframe>
    <div v-else class="empty-else">
      <div class="empty-form-report">
        <img :src="image" class="no-data" width="300" />
        <span class="image-text">
          <p>
            We are patiently waiting for you to select your<br />
            parameters and run your report...
          </p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import reportImage from "../assets/images/report-request-await.png";
export default {
  props: {
    dataSource: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      reportRequested: false,
      image: reportImage,
    };
  },
  computed: {
    setPdf() {
      return this.dataSource;
    },
  },
};
</script>

<style lang="scss">
.gc-report-pdf {
  height: 100%;
  .empty-else {
    height: 100%;
  }
  .empty-form-report {
    text-align: center;
    height: 100%;
    padding-top: 25%;
  }
  .image-text {
    p {
      color: rgba(102, 102, 102, 0.87);
      font-size: 17px;
    }
  }
}
</style>